import React from 'react'
import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  withState,
} from 'recompose'
import { connect } from 'react-redux'
import isNode from 'detect-node'
import { Redirect } from 'react-router-dom'
import get from 'lodash/get'
import flatten from 'lodash/flatten'
import map from 'lodash/map'
import filter from 'lodash/filter'
import find from 'lodash/find'

import VendorView from './VendorView'
import { addOrder, addFavouritesToOrder } from 'pages/order/modules/order'
import {
  addMultiVendorOrder,
  selectMultiVendorOrderItems,
  selectMultiVendorTotals,
} from 'pages/order/modules/multi.vendor.order'
import { loadVendor } from './modules/info'
import { formatMenu, loadMenu } from './modules/menu'
import { show, types, hide, selectVisibleModal } from 'store/modals'
import { isMultiVendor as isMultiVendorEnv } from 'utils/multiVendor'
import getHistory from 'services/history'
import { selectPrecinct } from 'store/precinct/selectors'
import { fetchProfile } from 'auth/modules/profile'
import Cookies from 'js-cookie'
import { COOKIE_FAVOURITES } from 'const/cookie'
import { getPrice } from 'utils/currency'
import { getDefaultOptions } from './MenuModal/helpers'
import { refreshOrderParty } from 'store/order-party/order-party.actions'
import moment from 'moment'
import { LOCAL_STORAGE_RWG_TOKEN, LOCAL_STORAGE_GFO_MERCHANT } from './const'
import { getQueryParams } from 'utils/url'
import { getConfig } from 'contexts/config-context'

export default compose(
  connect(null, (dispatch, ownProps) => ({
    showServingToTableModal: (tblNum, storageName) =>
      dispatch(show(types.SERVING_TO_TABLE, { tblNum, storageName })),
    showDisabledVenueModal: (heading, buttonLabel) =>
      dispatch(show(types.GENERIC, { heading, buttonLabel })),
    hideDisabledVenueModal: () => dispatch(hide(types.GENERIC)),
    refreshOrderParty: venueId => dispatch(refreshOrderParty(venueId)),
  })),

  connect(
    (state, props) => {
      const { isMultiVendor } = get(state, `vendor.info.info`)
      const {
        ordersQuantity,
        ordersSubTotal,
        discountTotal,
        feesTotal,
      } = selectMultiVendorTotals(state)

      const favourites = JSON.parse(Cookies.get(COOKIE_FAVOURITES) || '[]')

      const { accounts, address, balance, ...profile } = get(
        state,
        'profile.customer',
      )

      return {
        ...state.vendor.info,
        order:
          isMultiVendor && isMultiVendorEnv()
            ? get(state, `multiVendorOrder.orders.${props.match.params.id}`)
            : get(state, `order.orders.${props.match.params.id}`),
        precinct: selectPrecinct(state),
        combinedSubTotalAmount: ordersSubTotal,
        combinedFeesAmount: feesTotal,
        combinedDiscountAmount: discountTotal,
        combinedOrdersQuantity: ordersQuantity,
        combinedSelectedOrders: selectMultiVendorOrderItems(state),
        visibleModal: selectVisibleModal(state),
        favourites,
        vendorMenu: {
          menu: get(state, 'vendor.menu.menus'),
          id: get(state, 'vendor.menu.id'),
        },
        profile,
        isAuthenticated: get(state, 'auth.isAuthenticated'),
      }
    },
    {
      addOrder,
      addMultiVendorOrder,
      loadMenu,
      loadVendor,
      fetchProfile,
      addFavouritesToOrder,
      show
    },
  ),

  withState('isNotFound', 'setIsNotFound', false),

  lifecycle({
    bootstrap() {
      const {
        match,
        loadMenu,
        loadVendor,
        setIsNotFound,
        precinct,
        vendorMenu,
        show,
        location
      } = this.props
      const venueId = match.params.id
      const servicetype = 'takeaway'

      const s3config = getConfig()

      if (get(s3config,'features.gfo_order_attribution.enabled')) {

        const { rwg_token } = getQueryParams(location.search)
  
        if (rwg_token) {
          const tokenExpiry = moment().add(2592000,'seconds')
          localStorage.setItem(LOCAL_STORAGE_RWG_TOKEN,rwg_token)
          localStorage.setItem(LOCAL_STORAGE_GFO_MERCHANT,venueId)
          localStorage.setItem(`${LOCAL_STORAGE_RWG_TOKEN}-expiry`,tokenExpiry)
          localStorage.setItem(`${LOCAL_STORAGE_GFO_MERCHANT}-expiry`,tokenExpiry)
        } 
      }



      return Promise.all([
        loadVendor(venueId),
        loadMenu(venueId, { servicetype }),
      ])
        .then(async res => {
          const { info, favourites, addFavouritesToOrder } = this.props

          const menuInfo = get(res, '[1].payload', vendorMenu)

          const vendorInfo = get(res,'[0].payload')

          const busyUntil = get(vendorInfo,'busyUntil')

          const vendorTz = get(vendorInfo,'vendorProperty.timezone')

          const busyDate = moment(busyUntil).tz(vendorTz,true)

          const now = moment().tz(vendorTz, true)

          if (busyUntil && busyDate.isValid()) {
            const remainingMinutes = Math.floor(moment.duration(busyDate.diff(moment().tz(vendorTz, true))).asMinutes())
            show(types.GENERIC, {
              heading: busyDate.isBefore(now) && remainingMinutes <=  0? `Sorry we’re temporarily unavailable` : `Sorry, we're unavailable right now, but we'll be back online in ${remainingMinutes} minutes!`,
              buttonLabel: 'Got it',
              mobileOnly: true
            })
          }

          if (
            get(favourites, 'venueId') === parseInt(get(menuInfo, 'id', 0), 10)
          ) {
            const menuItems = flatten(map(menuInfo.menu, item => item.items))

            const orders = filter(menuItems, menu =>
              find(
                get(favourites, 'items'),
                favourite => get(favourite, 'id') === get(menu, 'id'),
              ),
            )

            const orderSummary = map(orders, orderItem => ({
              ...orderItem,
              quantity: 1,
              unitPrice: getPrice(orderItem.price),
              serialisedOptions: JSON.stringify(
                getDefaultOptions(formatMenu(orderItem)),
              ),
            }))

            await addFavouritesToOrder(venueId, orderSummary)
            Cookies.remove(COOKIE_FAVOURITES)
          }

          if (isMultiVendorEnv() && !get(info, 'isMultiVendor'))
            get(precinct, 'tag')
              ? getHistory().push(`/precinct/${get(precinct, 'tag')}`)
              : getHistory().push(`/precinct`)
        })
        .catch(error => {
          if (error.response.status === 404) setIsNotFound(true)
        })
    },

    componentDidMount() {
      if (!isNode) this.bootstrap()
    },
  }),

  branch(
    p => p.isNotFound,
    renderComponent(() => <Redirect to="/404" />),
  ),
)(VendorView)
